export function hasPermission( user, permissionType ) {
    const { claims } = user;
    const { permissions } = claims;

    if ( !permissions || !permissions[ 'navigation-service' ] ) {
        return false;
    }

    const navigationPermission = permissions[ 'navigation-service' ];

    if ( navigationPermission && navigationPermission.includes( permissionType ) ) {
        return true;
    } else {
        return false;
    }
}

export function getPagePermission ( permission ) {
    if ( window.location.href.includes( 'definition' ) ) {
        return `navigation-service.${ permission }-menu-definition`;
    } else if ( window.location.href.includes( 'configuration' ) ) {
        return `navigation-service.${ permission }-menu-configuration`;
    } else {
        return `navigation-service.${ permission }-menu-type`;
    }
}

export default hasPermission;